import IconButton from "@material-ui/core/IconButton";
import styled from "@material-ui/core/styles/styled";


export const StyledRoot = styled("div")({
    position: "relative",
    overflow: "hidden",
});

export const StyledItem = styled("div")({
    position: "absolute",
    height: "100%",
    width: '100%',
    //    flexGrow: 1
});

export const StyledItemWrapper = styled("div")({
    position: 'relative',
    width: '100%',
    height: '100%',
});

export const StyledIndicators = styled("div")({
    width: "100%",
    marginTop: "2px",
    textAlign: "center"
});

export const StyledIndicatorIconButtonActive = styled(
    IconButton
)<{ $active: boolean }>(({ theme }) => ({
    cursor: "pointer",
    transition: "200ms",
    padding: 0,
    color: "#494949",
    '&:hover': {
        color: "#494949",
    },
    '&:active': {
        color: "#494949",
    }
}));

export const StyledIndicatorIconButtonNonActive = styled(
    IconButton
)<{ $active: boolean }>(({ theme }) => ({
    cursor: "pointer",
    transition: "200ms",
    padding: 0,
    color: "#afafaf",
    '&:hover': {
        color: "#1f1f1f",
    },
    '&:active': {
        color: "#1f1f1f",
    }
}));

export const StyledIconButton = styled(
    IconButton
)<{ $alwaysVisible: boolean; $fullHeightHover: boolean }>(({ theme }) => ({
    margin: "0 10px",
    position: "relative",
    backgroundColor: "#494949",
    top: "calc(50% - 20px) !important",
    color: "white",
    fontSize: "30px",
    transition: "200ms",
    cursor: "pointer",
    opacity: theme.$alwaysVisible ? '1' : '0',
    '&:hover': {
        opacity: "0.6 !important",
    },
}));

export const StyledButtonWrapper = styled(
    "div",
)<{ $next: boolean; $prev: boolean; $fullHeightHover: boolean }>(({ theme }) => ({
    position: "absolute",
    height: "100px",
    backgroundColor: "transparent",
    zIndex: 1,
    top: "calc(50% - 70px)",
    '&:hover': {
        '& button': {
            backgroundColor: "black",
            filter: "brightness(120%)",
            opacity: "0.4"
        }
    },
    ...(theme.$fullHeightHover ? {
        height: "100%", // This is 100% - indicator height - indicator margin
        top: "0"
    } : undefined),
    ...(theme.$next ? { right: 0 } : undefined),
    ...(theme.$prev ? { left: 0 } : undefined),
}));